import { Children, cloneElement, isValidElement, ReactElement } from 'react';
import { TabHeaderProps } from './tabTypes';
import useTabsState from './useTabsState';

const TabHeader: React.FC<TabHeaderProps> = ({ children }) => {
    const { tabIndex, setTabIndex } = useTabsState();

    const allChildren = Children.map(children, (child, index) =>
        isValidElement(child)
            ? cloneElement(child as ReactElement, {
                  active: tabIndex === index,
                  onClick: () => {
                      child.props.onClick && child.props.onClick();
                      setTabIndex(index);
                  },
              })
            : 'invalid element'
    );

    return <div className='tabs-header-container'>{allChildren}</div>;
};

export default TabHeader;
